<script>
	import HeaderMenuItem from './HeaderMenuItem.svelte';
	import { profile } from './images/icons.svelte';

	let { active } = $props();
</script>

<HeaderMenuItem transparent position="left">
	{#snippet title()}
		<span
			class={[
				'fill-white text-white',
				{
					' md:fill-indow-blue md:text-indow-blue': active,
				},
				{
					' md:fill-inherit md:text-inherit': !active,
				},
			]}
		>
			<span class="flex flex-col gap-1 text-sm">
				<span class="w-7 place-self-center">
					{@render profile()}
				</span>
				<span
					class="
       hidden
       md:inline
     ">SIGN IN</span
				>
			</span>
		</span>
	{/snippet}
	<ul class="list-none pt-3 text-left font-medium whitespace-nowrap">
		<li class="m-0">
			<a
				href="/how-to/get-indow-inserts"
				class="
      block px-6 py-3 text-inherit no-underline
      hover:bg-gray-100
    ">Sign Up</a
			>
		</li>
		<li class="m-0">
			<a
				href="/signin"
				class="
      block px-6 py-3 text-inherit no-underline
      hover:bg-gray-100
    ">Sign In</a
			>
		</li>
	</ul>
</HeaderMenuItem>
